var constants = require('../constants');
var api = require('../../../utils/api');
var commonActions = require('../../common/actions/common');

var TargetsActions = (function(){

    var _requestTargets = function() {
        return {
            type: constants.REQUEST_TARGETS
        };
    }

    var _receiveTargets = function(data) {
        return {
            type: constants.RECEIVE_TARGETS,
            data: data
        };
    }

    var _fetchTargets = function(token) {
        return function (dispatch) {
            dispatch(_requestTargets());
            return api.get('/proxy/v1/admin/lists', token).then(function (response) {
                return response;
            }).then(function (data) {
                return dispatch(_receiveTargets(data));
            }).catch(function(error){
                if(error.response){
                    dispatch(commonActions.setGenericResponseError('', error.response));
                }else{
                    dispatch(commonActions.setGenericError('', error.message));
                }
            });
        };
    }

    var _shouldFetchTargets = function(state) {
        var targets = state.targets;
        if (Object.keys(targets.data).length === 0) {
            return true;
        } else {
            return false;
        }
    }

    var _fetchTargetsIfNeeded = function(token) {
        return function(dispatch, getState) {
            if (_shouldFetchTargets(getState())) {
                return dispatch(_fetchTargets(token))
            }
        }
    }

    return {
        fetchTargets: _fetchTargets,
        fetchTargetsIfNeeded: _fetchTargetsIfNeeded
    }
})();

module.exports = TargetsActions;



// WEBPACK FOOTER //
// ./src/common/modules/targets/actions/targets.js